module.exports = "<ng-template appInsertion> </ng-template>"